import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  },
  actions: {
    getTodosPedidosDia ({commit}, payload) {
      // const me = this
      console.log('getTodosPedidosDia action')
      return Vue.http.post('/api/admin/pedidos/all', {
        fecha: payload.fecha
      })
    },
    getUsuariosEmpresa ({commit}, idEmpresa) {
      return Vue.http.post('/api/admin/usuariosempresa', {
        idEmpresa: idEmpresa
      })
    },
    getUsuariosActivosEmpresa ({commit}, idEmpresa) {
      return Vue.http.post('/api/admin/usuariosactivosempresa', {
        idEmpresa: idEmpresa
      })
    },
    initAdminRoot ({commit}) {
      return Vue.http.post('/api/admin/initadminpedidos')
    },
    initStats ({commit}) {
      return Vue.http.post('/api/admin/stats/init')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js